// ##############################
// // // PLAN D'ACTIONS
// #############################

// ##############################
// // // PLAN D'ACTION
// #############################

const planActions = {
  general: {
    name: "Nom",
    code: "Code / clé",
    groups: "Périmètre",
    description: "Description - Objectifs",
    status: "Statut du plan action",
    lastupdate: "Date de dernière mise à jour Statut",
    prevstartdate: "Date de début prévue",
    prevenddate: "Date de fin prévue",
    realstartdate: "Date de début réel",
    realenddate: "Date de fin réel",
    personincharge: "Responsable en charge",
    orgincharge: "Organisation en charge",
  },
  characteristics: {
    reclevel: "Niveau de recommendation",
    grade: "Note de criticité",
    priority: "Note de Priorité",
  },
  reference: {
    refstartdate: "Début de la période de référence",
    refenddate: "fin de la période de référence",
    electricityrefconsumption:
      "Electricité (MWh): consommation année de référence",
    gasrefconsumption:
      "Gaz naturel réseaux (MWh) : consommation année de référence",
    waterrefconsumption: "Eau (m3) : consommation",
    liquidgasrefconsumption:
      "Gaz naturel liquéfié (MWh) : consommation année de référence",
    propanerefconsumption: "Gaz propane (MWh): consommation année de référence",
    propanekgrefconsumption:
      "Gaz propane (MWh): consommation année de référence",
    butanem3refconsumption: "Gaz butane (m3): consommation année de référence",
    butanekgrefconsumption: "Gaz butane (MWh): consommation année de référence",
    fuelrefconsumption:
      "Fioul domestique (MWh) : consommation année de référence",
    heatrefconsumption:
      "Réseau de chaleur (MWh) : consommation année de référence",
    coldrefconsumption:
      "Réseau frigorifique (MWh) : consommation année de référence",
    coalrefconsumption:
      "Charbon agglomérés et briquettes (MWh) : consommation année de référence",
    houillerefconsumption: "Houille (MWh) : consommation année de référence",
    industrywoodrefconsumption:
      "Bois Plaquettes d'industrie (MWh) : consommation année de référence",
    forestwoodrefconsumption:
      "Bois Plaquettes forestières (MWh) : consommation année de référence",
    granulewoodrefconsumption:
      "Bois Granulés (pellets) ou briquettes (MWh) : consommation année de référence",
    logwoodrefconsumption:
      "Bois Bûches (MWh) : consommation année de référence",
    heatnetworkrefconsumption:
      "Réseau de chaleur (MWh) : consommation année de référence",
    coldnetworkrefconsumption:
      "Réseau de frigorifique (MWh) : consommation année de référence",
    woodrefconsumption:
      "Bois (MWh) : consommation année de référence",
    refConsumptionSource: "Source des conso de reference",
  },
  goals: {
    electricityobjconsumption: "Electricité : consommation annuelle objectif / % d'économies",
    gasobjconsumption: "Gaz naturel réseaux : consommation annuelle objectif / % d'économies",
    waterobjconsumption: "Eau : consommation annuelle objectif / % d'économies",
    propaneobjconsumption: "Gaz propane : consommation annuelle objectif / % d'économies",
    fuelobjconsumption: "Fioul domestique : consommation annuelle objectif / % d'économies",
    heatnetworkobjconsumption: "Réseau de chaleur : consommation annuelle objectif / % d'économies",
    coldnetworkobjconsumption: "Réseau frigorifique : consommation annuelle objectif / % d'économies",
    woodobjconsumption: "Bois : consommation annuelle objectif / % d'économies",
  },
  goalsUnits: {
    electricityobjconsumption: "MWh",
    gasobjconsumption: "MWh",
    waterobjconsumption: "m3",
    propaneobjconsumption: "MWh",
    fuelobjconsumption: "MWh",
    heatnetworkobjconsumption: "MWh",
    coldnetworkobjconsumption: "MWh",
    woodobjconsumption: "MWh",
  },

  scenarios: {
    name: "Nom",
    code: "Code / clé",
    associatedActionPlan: "Plan d'actions associé ",
    associatedActions: "Actions associées",
    description: "Description - Objectifs ",
    activationdate: "Date d'activation",
    status: "Statut du Scénario ",
    lastupdate: "Date de dernière mise à jour Statut ",
    order: "Ordre",
    feasibility: "Niveau de faisabilité ",
    grade: "Note de criticité ",
    reclevel: "Niveau de recommendation ",
    comments: "Commentaires ",
  },
  actions: {
    name: "Nom",
    code: "Code / clé",
    associatedActionPlan: "Plan d'actions associé ",
    description: "Description - Objectifs ",
    status: "Statut du Scénario ",
    lastupdate: "Date de dernière mise à jour Statut ",
    groups: "Périmètre",
    category: "Catégorie de l'action",
  },
  comments: "Commentaires / Remarques",
};

// ##############################
// // // ACTION
// #############################

export { planActions };
